import { PlanBenefitTypes } from "@/types";
import { request } from "./request";

/**
 * Get Plan Benefit List
 * @param PlanBenefitTypes.PlanBenefitQueryOptions
 * @param authToken Authorization token header to be added to make the call
 * @returns The list of Plan benefits filtered by the optionally specified filter.
 */
export async function getPlanBenefitList(
  payload: PlanBenefitTypes.PlanBenefitQueryOptions,
  authToken: string,
): Promise<PlanBenefitTypes.PlanBenefitSearchResults> {
  const response = await request<PlanBenefitTypes.PlanBenefitSearchResults>(
    {
      url: "/plan_benefit/list",
      method: "POST",
      data: payload,
    },
    authToken,
  );

  return response;
}
